import { Card, CardContent, Divider, Table, TableBody, TableCell, TableRow } from '@mui/material';
import clsx from 'clsx';

import { useStyles } from './style';
import AdjustedSkeleton from '../AdjustedSkeleton';

interface LoadingDetailsBlockProps {
	className?: string;
}

const LoadingDetailsBlock = (props: LoadingDetailsBlockProps) => {
	const classes = useStyles();

	const { className } = props;

	return (
		<Card className={clsx(classes.root, className)}>
			<div className={classes.header}>
				<AdjustedSkeleton animation='wave' width='50%' />
			</div>
			<Divider />
			<CardContent className={classes.content}>
				<Table>
					<TableBody>
						<TableRow>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
						</TableRow>
						<TableRow selected>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
						</TableRow>
						<TableRow>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
						</TableRow>
						<TableRow selected>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
							<TableCell>
								<AdjustedSkeleton animation='wave' />
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			</CardContent>
		</Card>
	);
};

export default LoadingDetailsBlock;
